import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch4_p08} from "../../../layouts/ch4_p08/ch4_p08"

export class Chapter4Page8 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly guitar = this.addChild(new SceneSprite());
    readonly basket = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());

    readonly phoneContainer = this.addChild(new PIXI.Container());
    readonly phone = this.phoneContainer.addChild(SceneSprite.withPrefix("ch4_p08/"));
    readonly notification = this.phoneContainer.addChild(SceneSprite.withPrefix("ch4_p08/"));
    readonly shine = this.phoneContainer.addChild(SceneSprite.withPrefix("ch4_p08/"));

	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch4_p08/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch4_p08/"));
	readonly lines = this.addChild(new SceneSprite());

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch4_p08.call(this);
        this.frameLeft.visible = false;
		this.frameRight.visible = false;

		// super.init calls onResize
        super.init(pSize, pData);

        // interactivity
        this.phone.interactive = true;
        this.phone.buttonMode = true;
        this.phone.accessible = true;
        this.phone.addListener(HLF.Input.Events.POINTER_TAP, e=>{
            this.gotoNextState({transition: "ontop"});
        });
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
        new TimelineLite()
            .fromTo(this.phoneContainer, 2,
                {pixi: {y: this._size.y + this.phoneContainer.height / 2}}, // offscreen
                {pixi: {y: this.phoneContainer.y + 500}}, // start position in next panel
            )
            .delay(3.75)
        ;
    }

    public animateOut(pOnComplete: ()=>void) {
        this.phoneContainer.visible = false;
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
    }
}